"use client";
function t(){try{return window.self!==window.top}catch(t){return!0}}export{t as isInIframe};
